const CONDITION_STATES_TO = Object.freeze({
  VALUE: 0,
  ANOTHER_FIELD: 1,
});

export {CONDITION_STATES_TO}




// WEBPACK FOOTER //
// ./src/enums/conditionStatesTo.js